"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var usePageGroupQuestions = function usePageGroupQuestions(questions) {
  var _useState = (0, _react.useState)([]),
      items = _useState[0],
      setItems = _useState[1];

  (0, _react.useEffect)(function () {
    setItems(questions);
  }, [questions]);
  var getListLength = (0, _react.useCallback)(function () {
    return items.length;
  }, [items.length]);
  return {
    items: items,
    getListLength: getListLength
  };
};

var _default = exports["default"] = usePageGroupQuestions;